import { createServiceDropdown } from "./fancy-dropdowns.3e2d7c0fd3ef.js";
import CustomAmplitudeClient from "./custom-amplitude-client.8d2468912b6f.js";
import"./contact-us.269e211569d4.js";
import {
  ServiceSelectorChangedEvent,
  ServiceSelectorClearedEvent,
  parseServiceSelection,
} from "./service-selector-events.5a616c64e072.js";
import { InsuranceSelectorChangedEventType } from "./insurance-selector-events.541824bb3263.js";
import { MOBILE_SCREEN_QUERY } from "./shared.3c04262e7f5d.js";

export class SearchForm extends HTMLElement {
  constructor() {
    super();

    this.root = this.getRootNode();
    this.config = JSON.parse(
      this.root.querySelector("#page-config").textContent,
    );

    if (!this.config) throw new Error("unable to load page config");
    this.amplitudeClient = new CustomAmplitudeClient(this.config.analyticsUrl);
  }

  connectedCallback() {
    const searchBarContainer = this.root.querySelector(".search-bar");
    this.amplitudeClient.setupSearchBarAnalytics(searchBarContainer);

    const form = this.root.querySelector("#rates-form");
    if (form) {
      form.addEventListener("submit", this.handleFormSubmit);
    }

    this.root.addEventListener(
      InsuranceSelectorChangedEventType,
      this.clearInsuranceValidation,
    );

    const serviceCodeEl = this.root.querySelector("#service_code");
    this.serviceDropdown = createServiceDropdown(
      serviceCodeEl,
      this.config.servicesUrl,
      this.config.browseUrl,
    );

    this.serviceDropdown.on("change", this.handleServiceSelectionChange);
    this.serviceDropdown.on("change", this.advance);
  }

  handleServiceSelectionChange = () => {
    const serviceSelector = this.root.querySelector("#service_code");
    if (!serviceSelector) {
      return;
    }

    const selectedValue = this.serviceDropdown.getValue();
    const hasSelection =
      Array.isArray(selectedValue) && selectedValue.length === 0
        ? false
        : Boolean(selectedValue);
    const value = Array.isArray(selectedValue)
      ? selectedValue[0]
      : selectedValue;
    const event = hasSelection
      ? new ServiceSelectorChangedEvent({ value })
      : new ServiceSelectorClearedEvent();

    serviceSelector.dispatchEvent(event);

    if (hasSelection) {
      this.amplitudeClient.trackEvent("service_selected", {
        ...parseServiceSelection(value),
        product_flow: this.config.productFlow,
        search_stage: this.config.searchStage,
      });
    }
  };

  clearInsuranceValidation = () => {
    const validationAnchor = this.root.querySelector(
      ".insurance-validation-anchor",
    );
    if (validationAnchor) {
      validationAnchor.setCustomValidity("");
    }
  };

  handleFormSubmit = (e) => {
    const form = e.target;
    const networkConfigInput = form.querySelector('input[name="plan"]');

    if (networkConfigInput && !networkConfigInput.value) {
      e.preventDefault();
      const validationAnchor = this.root.querySelector(
        ".insurance-validation-anchor",
      );
      if (validationAnchor) {
        validationAnchor.setCustomValidity("Please select an insurance plan");
        validationAnchor.reportValidity();
      }
    }
  };

  advance = () => {
    if (MOBILE_SCREEN_QUERY.matches) {
      document.activeElement?.blur();
    } else {
      this.root.getElementById("care-location").focus();
    }
  };
}

customElements.define("search-form", SearchForm);
